import cogoToast from "cogo-toast-react-17-fix";
import React, { useState, useEffect } from 'react';
import { BASE_URL, USER_TOKEN, GET_ALL_PREDEFINED_TEMPLATES, GET_ALL_PACKAGES } from "../../../Utils/constant";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "../CompanyProfile.module.css";
import templateStyles from "./Templates.module.css"

import API from '../../../ApiConfig'
import useRefreshToken from "../../../Hooks/usegenerateToken";
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import IssuerNavigator from '../../../components/DashBoard/IssuerNavigator';
import NavLinks from '../../../components/NavLinks';
import TemplatesTable from './Templatestable';


// import { data } from "./mockdata";
import Pagination from '../ExternalDash/Pagination';
import FormsTable from './FormsTable';

const GlobalTemplates = () => {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)


    const [totalPages, setTotalPages] = useState(1);

    const [MenuLinks, setMenuLinks] = useState([
        { name: "All", link: "", pos: 0 },
        { name: "Pending", link: "UNCONFIRMED", pos: 1 },
        { name: "Done", link: "ACTIVE", pos: 2 },
    ])
    const [activeTab, setActiveTab] = useState(MenuLinks[0])

    const [sortBy, setSortBy]=useState({
        key:"updated_at",
        direction:"desc"
    })
    const [searchText, setSearch]=useState("")
    const strings = {
        '/templates': {
            title: 'Global Templates',
            buttonText: '+ Create Template',
            apiurl: GET_ALL_PREDEFINED_TEMPLATES,
            navigateTo: '/company/1/2/newDocument'
        },
        '/forms': {
            title: 'Global Forms',
            buttonText: '+ Create New Form',
            apiurl: GET_ALL_PACKAGES,
            navigateTo: '/company/2/2/newForm'
        }
    }
    const [page_content, setpageContent] = useState(strings[location.pathname])

    useEffect(() => {
        setpageContent(strings[location.pathname])
    }, [location.pathname])

    const [SelectDocs, setSelectDocs] = useState([])
    const [activeList, setActivelist] = useState([])

    const get_documents = async () => {
        setLoading(true)
        API.get(location.pathname == '/forms' ? GET_ALL_PACKAGES : GET_ALL_PREDEFINED_TEMPLATES, {
            params: {
                status: activeTab?.link,
                page_number: currentPage,
                sort_by:sortBy.key,
                search:searchText,
                sort_order:sortBy.direction

            }
        })
            .then(res => {
                if (res.data.status === 200) {
                    setLoading(false)
                    let { data } = res.data
                    setSelectDocs(data.items)
                    setActivelist(data.items)
                    setTotalPages(data.total_pages)
                }
            })
            .catch(err => {
                cogoToast.error(err.message)
            }).finally(() => {
                setLoading(false)
            }
            )
    }
    const [currentPage, setCurrentPage] = useState(1);

    

    useEffect(()=>{
        const delayDebaounce=setTimeout(()=>{
            get_documents()
        },700)


        return ()=> clearTimeout(delayDebaounce)
    },[searchText,activeTab, currentPage, location.pathname, sortBy])

    function handleActiveTab(e) {
        setActiveTab(e)
    }

    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    }
    return (
        <SlideUpWrapper direction="slide-left">
            <div className={[styles.companyProfile, templateStyles.templateHeader].join(" ")}>
                <IssuerNavigator
                    title={page_content?.title}
                    actions={() =>
                        <button onClick={() => navigate(page_content?.navigateTo)} className="btn btn-primary" style={{ width: "12rem" }}>
                            <div>{page_content?.buttonText}</div>
                        </button>
                    } step={'/'} />
                <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} ischangeRequested={false} />
            </div>

            {
                location.pathname == '/forms' ? <FormsTable data={activeList} title={activeTab?.name} setSortBy={setSortBy} sortBy={sortBy} get_documents={get_documents} setFormSearch={setSearch} searchText={searchText} /> :
                    <TemplatesTable data={activeList} title={activeTab?.name} setSortBy={setSortBy} sortBy={sortBy} get_documents={get_documents} setTemplateSearch={setSearch} searchText={searchText} />

            }

            <div style={{ margin: "10px" }}>
                <Pagination
                    nPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onPageChange={handlePageChange}
                    loading={loading}
                />
            </div>
        </SlideUpWrapper>
    )

};

export default GlobalTemplates;